import React from 'react'

export const VoxelIcon: React.FC = () => (
  <svg viewBox='0 0 34 34' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M29.75 22.6666V11.3333C29.7495 10.8364 29.6183 10.3484 29.3697 9.91826C29.121 9.48809 28.7636 9.13087 28.3333 8.88244L18.4167 3.21578C17.9859 2.9671 17.4974 2.83618 17 2.83618C16.5026 2.83618 16.0141 2.9671 15.5833 3.21578L5.66667 8.88244C5.23637 9.13087 4.87897 9.48809 4.63032 9.91826C4.38167 10.3484 4.25051 10.8364 4.25 11.3333V22.6666C4.25051 23.1635 4.38167 23.6515 4.63032 24.0816C4.87897 24.5118 5.23637 24.869 5.66667 25.1174L15.5833 30.7841C16.0141 31.0328 16.5026 31.1637 17 31.1637C17.4974 31.1637 17.9859 31.0328 18.4167 30.7841L28.3333 25.1174C28.7636 24.869 29.121 24.5118 29.3697 24.0816C29.6183 23.6515 29.7495 23.1635 29.75 22.6666Z'
      stroke='currentColor'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M4.63257 9.85999L17.0001 17.0142L29.3676 9.85999'
      stroke='currentColor'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M17 31.28V17'
      stroke='currentColor'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
)
